import React from 'react';
import { Field, Form } from 'redux-form';
import { withStyles } from 'material-ui';

import { Checkbox, required } from 'entoro-shared';

const styles = () => ({
  container: {
    margin: '0 auto',
  },
  title: {
    fontSize: '16px',
    marginBottom: '10px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
    marginBottom: '10px',
  },
});

const SuitabilityQuestion = ({
  change,
  handleSubmit,
  disabled,
  paymentDetails,
  offer,
  tenant,
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <div style={{ float: 'left', maxWidth: '100%' }}>
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_one'
          label={`I understand early stage businesses are very risky. I can afford to lose the entirety of all investments I make in ${offer.name}.`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_two'
          label={`I understand that securities in ${offer.name} are not easily re-sold. The lack of mature secondary markets or exchanges for these securities means that—even if I do find a buyer—I may not be able to obtain a fair price, and that it can take years to realize a return.`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_three'
          label={`I understand Entoro Securities does not offer investment advice. I am sufficiently financially sophisticated and educated to evaluate companies based on the materials provided, and to make independent investment decisions.`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_four'
          label={`I affirm that everything in this application is true to my knowledge.`}
        />
      </div>

      <div className='full-line' />
      {/* <input
        type='submit'
        value='Save'
        disabled={disabled}
        className={`button-2 w-button ${disabled ? 'btn-disabled' : ':'}`}
      /> */}
      <br />
    </Form>
  );
};

export default withStyles(styles)(SuitabilityQuestion);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/SutabilityQuestion.js